// export const aboutData = {
//     title: "Who I am",
//     description1: "Welcome to Smruti Ranjan Dhal's Digital Playground",
//     description2: "Greetings, fellow coders and curious minds! I am Smruti Ranjan Dhal, a passionate and results-driven software developer on a mission to turn innovative ideas into robust, scalable solutions. With a blend of creativity and technical prowess, I bring a unique perspective to the ever-evolving world of software development.",
//     image: 2
// }

export const aboutData = {
  title: "Who I Am",
  description1: "Welcome to Smruti Ranjan Dhal’s Digital Engineering Portfolio",
  description2:
    "I am a Frontend-Focused Full Stack Software Developer with 4.2+ years of experience designing and delivering enterprise-grade applications using React.js, TypeScript, Redux, JavaScript (ES6+), and modern UI frameworks. I have worked in Deloitte and fast-paced product environments, building scalable UI systems, optimizing application performance, reducing load times by up to 90%, and improving user engagement by 80%. Passionate about clean architecture, reusable component systems, performance optimization, and delivering seamless digital experiences through Agile collaboration and data-driven engineering.",
  image: 2,
};
